export default {
    container: {
        backgroundColor: '#f1f1f1',
    },
    header: {
        color: '#ffffff',
        backgroundColor: '#344955',
    },
    nav: {
        borderColor: '#344955',
        color: '#344955',
        activeColor: '#344955',
        backgroundColor: '#f9aa33'
    },
    content: {
        color: '#344955',
        borderColor: '#344955',
        hoverColor: 'purple',
    },
    footer: {
        color: 'lightblue',
        backgroundColor: 'transparent',
        btnColor: '#344955',
        activeBtnColor: '#ffffff', 
    }
};